import { defineComponent as _defineComponent } from 'vue'
import UserInfoDataService from "@/services/UserInfoDataService";
import { store } from "@/store/store";
import ResponseData from "@/types/ResponseData";
import { useRouter } from "vue-router";
import { useI18n } from "vue3-i18n";

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const i18n = useI18n();
const router = useRouter();

const onClickLogo = () => {
  checkApprovalRequest();
};

/** 成り代わりログアウトの処理 */
const logoutClick = () => {
  /* 成り代わりログアウトのログを登録する */
  const userValue = store.state.oriLoginUserInfo[0];
  const param = {
    loginUserId: userValue.userId,
    controlNumber: userValue.loginNumber,
    accessLog: store.state.accessLog,
    targetUserId: store.getters.cognitoUserName,
    targetUserStation: store.getters.stationCode,
    loginState: "logout"
  }
  UserInfoDataService.insertAlternativeLogin(param)
    .then((_) => {
      console.log("logout success");
      store.dispatch("setReturnFirstMostUserData");
      router.push("/");
      store.dispatch("setShowPage", "/");
      store.dispatch("setIsAltLogin", false);
      store.dispatch("setIsAltLogout", true);
      store.dispatch("setSubMenuList", null);
    })
    .catch((e: Error) => {
      console.log(e);
      if(e.response.data.dbException != undefined){
        const firstError = e.response.data.dbException[0];
        alert(i18n.t("err081") + i18n.t("err080").replace("errorMessageValue", firstError.message));
      }else {
        alert(i18n.t("err081") + i18n.t("err080").replace("errorMessageValue", e.response.data.message));
      }
    });
};

/** 承認依頼があるかチェック */
const checkApprovalRequest = () => {
  const data = {'userId': store.getters.cognitoUserName};
  UserInfoDataService.checkApprovalRequest(data)
  .then((response: ResponseData) => {
    var data = response.data;
    var msgVal = "You have received a request to confirm User Approval or/and Menu Approval. Please go to the page from Admin menu.";
    if(data.isNodeAdminNotice || data.isSmcAdminNotice){
      store.dispatch("setApprovalNotice", msgVal);
    }else{
      store.dispatch("setApprovalNotice", "");
    }
    router.push("/");
    store.dispatch("setShowPage", "/");
  })
};

const __returned__ = { i18n, router, onClickLogo, logoutClick, checkApprovalRequest, store }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})